import {
    type LessonPlayerAlgorithmUiContext,
    type ReviewPreviousMaterialAlgorithmUiContext,
    UI_CONTEXT_EXPLAIN_SCREEN,
    UI_CONTEXT_LESSON_PLAYER_SUPPORT,
    UI_CONTEXT_REVIEW_LESSON,
    UI_CONTEXT_REVIEW_PREVIOUS_MATERIAL,
    type BotUiContext,
} from 'TutorBotConversation';

export function isLessonPlayerAlgorithmUiContext(uiContext: BotUiContext): uiContext is LessonPlayerAlgorithmUiContext {
    return [UI_CONTEXT_EXPLAIN_SCREEN, UI_CONTEXT_LESSON_PLAYER_SUPPORT].includes(uiContext);
}

export function isReviewPreviousMaterialAlgorithmUiContext(
    uiContext: BotUiContext,
): uiContext is ReviewPreviousMaterialAlgorithmUiContext {
    return [UI_CONTEXT_REVIEW_PREVIOUS_MATERIAL, UI_CONTEXT_REVIEW_LESSON].includes(uiContext);
}
